import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { ItemCategory } from "@/domains/inventory/constants/itemCategory";

export function getGroupsFromItems(items: InventoryItem[]): ItemCategory[] {
  const groups = new Set<ItemCategory>();
  for (const item of items) {
    groups.add(item.itemTemplate.category as ItemCategory);
  }
  return Array.from(groups);
}
